import { render, staticRenderFns } from "./zzzb.vue?vue&type=template&id=09a71e2a"
import script from "./zzzb.vue?vue&type=script&lang=js"
export * from "./zzzb.vue?vue&type=script&lang=js"
import style0 from "./zzzb.vue?vue&type=style&index=0&id=09a71e2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports